import { render, staticRenderFns } from "./AdminHospitalEdit.vue?vue&type=template&id=35f235d0"
import script from "./AdminHospitalEdit.vue?vue&type=script&lang=js"
export * from "./AdminHospitalEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports